<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="基地">
              <j-dict-select-tag ref="baseRef"  placeholder="请选择基地"  v-model="queryParam.baseId" :isChooseFirst="true" dictCode="bus_inspection_general_base,base,id,status=1"  >
              </j-dict-select-tag>
            </a-form-item>
          </a-col> 
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="角色">
              <a-select  v-model="queryParam.roleId" @focus="getBaseUserRole">
                <a-select-option v-for="(item) in userRoleList" :key="item.id" :value="item.id">
                  {{ item.roleName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> 
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="部门">
                <j-dict-select-tag placeholder="请选择部门"  v-model="queryParam.departId"  :dictCode="departIdDict"  ></j-dict-select-tag>
              </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="区域">
              <j-dict-select-tag placeholder="请选择区域"  v-model="queryParam.workshopId"  :dictCode="workshopIdDict"  ></j-dict-select-tag>
              </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="状态">
              <j-dict-select-tag v-model="queryParam.status" placeholder="请选择状态" dictCode="inspection_task_status"/>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="巡查人名称">
                  <j-input placeholder="请输入用户名称" v-model="queryParam.userName"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="6" :lg="7" :md="8" :sm="24">
                <a-form-item label="区域责任人姓名">
                  <j-input placeholder="请输入区域责任人姓名" v-model="queryParam.workshopUserName"></j-input>
                </a-form-item>
              </a-col>
              <a-col :xl="10" :lg="11" :md="12" :sm="24"  style="max-width:580px"  >
                <a-form-item label="开始时间">
                  <a-range-picker :value="dateRangePicker" @change="onCreateTimeChange" />
                  <!-- <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择开始时间" class="query-group-cust" v-model="queryParam.create_time_begin"></j-date>
                  <span class="query-group-split-cust"></span>
                  <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择结束时间" class="query-group-cust" v-model="queryParam.create_time_end"></j-date> -->
                </a-form-item>
              </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button> -->
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('巡检任务表')">导出</a-button> -->
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <!-- <a-button type="primary" icon="import">导入</a-button> -->
      </a-upload>
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        table-layout="auto"
        :scroll="{ x: tableWidth  }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <!-- <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

      </a-table>
    </div>
    <busInspectionTask-modal ref="modalForm" @ok="modalFormOk"></busInspectionTask-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import BusInspectionTaskModal from './modules/BusInspectionTaskModal'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import {  postAction  } from '@/api/manage'
  import JInput from '@/components/jeecg/JInput'
  import JDate from '@/components/jeecg/JDate'
  import moment from 'moment'
  import {  findInspectionRoleOfGeneral,busInspectionBaseList } from '@/api/api'

  export default {
    name: "BusInspectionTaskList",
    mixins:[JeecgListMixin],
    components: {
      BusInspectionTaskModal,JDictSelectTag,JInput,JDate
    },
    data () {
      return {
        tableWidth:2000,
        description: '巡检任务表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'任务名称',
            align:"center",
            width:250,
            dataIndex: 'taskName'
          },
          {
            title:'基地',
            align:"center",
            width:120,
            dataIndex: 'baseId_dictText'
          },
          {
            title:'部门',
            align:"center",
            width:120,
            dataIndex: 'departId_dictText'
          },
          {
            title:'区域',
            align:"center",
            width:180,
            dataIndex: 'workshopId_dictText'
          },
          {
            title:'责任人编号',
            align:"center",
            width:132,
            dataIndex: 'workshopUserNo'
          },
          {
            title:'区域责任人姓名',
            align:"center",
            width:132,
            dataIndex: 'workshopUserName'
          },
          {
            title:'巡查人',
            align:"center",
            width:150,
            dataIndex: 'userName'
          },
          {
            title:'巡查人编号',
            align:"center",
            width:150,
            dataIndex: 'userNo'
          },
          {
            title:'状态',
            align:"center",
            width:70,
            dataIndex: 'status_dictText'
          },
          {
            title:'开始巡查时间',
            align:"center",
            dataIndex: 'goInTime',
            width:170,
          },
          {
            title:'结束巡查时间',
            align:"center",
            dataIndex: 'goOutTime',
            width:170,
          },
          {
            title:'是否提交改善方案',
            align:"center",
            dataIndex: 'submitPlan',
            width:170,
          },
          {
            title:'改善完成时间',
            align:"center",
            dataIndex: 'submitPlanTime',
            width:200,
            customRender:function (text) {
              return !text?"":text
            }
          },
          {
            title:'任务开始时间',
            align:"center",
            dataIndex: 'expireStartTime',
            width:210,
            customRender:function (text) {
              return !text?"":text
            }
          },
          {
            title:'任务过期时间',
            align:"center",
            dataIndex: 'expireEndTime',
            width:210,

            customRender:function (text) {
              return !text?"":text
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/general/busInspectionTask/list",
          delete: "/general/busInspectionTask/delete",
          deleteBatch: "/general/busInspectionTask/deleteBatch",
          exportXlsUrl: "/general/busInspectionTask/exportXls",
          importExcelUrl: "general/busInspectionTask/importExcel",
        },
        userRoleList: [],
        departIdDict:"bus_inspection_general_base_depart,depart,id,status='1'",
        workshopIdDict:"bus_inspection_general_depart_workshop,workshop,id,status='1'",
        baseList:null,
      }
    },
    created() {
      let scrollWidth=this.columns.reduce((total,value,index)=>{
        if(index==1){
          return total.width+value.width;
        }
        return total+value.width;
      })
      this.tableWidth=scrollWidth;
      this.$nextTick(()=>{
        this.$refs.modalForm.initDictData()
      })
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      dateRangePicker(value){
        let dateStart=null;
        let dateEnd=null;
        if(this.queryParam.beginDate){
          dateStart=moment(this.queryParam.beginDate, "YYYY-MM-DD HH:mm:ss");
        }
        if(this.queryParam.endDate){
          dateEnd=moment(this.queryParam.endDate, "YYYY-MM-DD HH:mm:ss");
        }
        return [dateStart,dateEnd]
      }
    },
    methods: {
      initDictConfig(){
      },
      onCreateTimeChange(value){
        console.log(value)
        this.$set(this.queryParam,'beginDate',value[0].format("YYYY-MM-DD"))
        this.$set(this.queryParam,'endDate',value[1].format("YYYY-MM-DD"))
      },
      getBaseUserRole() {
        if (this.queryParam.baseId== '' && this.queryParam.baseId== null) { 
          this.$message.error('请先选择基地')
        }
      },
      busInspectionBaseList(){
        return new Promise((resolve,reject)=>{
          busInspectionBaseList({pageSize:100,pageNo:1}).then(res=>{
            if(res.code==200){
              resolve(res.result.records);
            }else{
              this.$message.error(res.message)
              reject([])
            }
          }).catch(error=>{
            this.$message.error(error.message)
            reject([])
          })
        })
      },
      async handlerBaseChange(newValue){
        if(newValue){
            this.departIdDict=`bus_inspection_general_base_depart,depart,id,status='1' AND base_id='${newValue}'`
            if(!this.baseList){
              this.baseList=await this.busInspectionBaseList();
            }
            //获取该基地下的角色信息
            this.$nextTick(()=>{
              let inspectionBase=""
              let baseLabel=this.$refs.baseRef.getSelectLabels()
              this.baseList.some(item=>{
                if(item.base===baseLabel){
                  inspectionBase=item.baseNo
                }
              })
              findInspectionRoleOfGeneral(inspectionBase).then((res) => {
                if (res.success) {
                  this.userRoleList = res.result
                  this.userRoleList.splice(0, 0, {
                    roleCode: '',
                    roleName: '全部',
                  })
                } else {
                  this.$message.error(res.message)
                }
              })
            })
            return
          }
          this.departIdDict="bus_inspection_general_base_depart,depart,id,status='1'"
      }
    },
    watch:{
      "queryParam.baseId":{
        deep:true,
        handler(newValue){
          this.handlerBaseChange(newValue)
        }
      },
      "queryParam.departId":{
        deep:true,
        handler(newValue){
          console.log("newValue")
          console.log(newValue)
          if(newValue){
            this.workshopIdDict=`bus_inspection_general_depart_workshop,workshop,id,status='1' AND depart_id='${newValue}'`
            return
          }
          this.workshopIdDict="bus_inspection_general_depart_workshop,workshop,id,status='1'"
        }
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>